export default __webpack_public_path__ + "static/client-3-360c535fd1a94baae082111d1ffbb3f6.webp";